import React from 'react'
import Layout from '../components/Layout'
import { Stores } from '../components/Setting/Stores'

export const BusinessStores = () => {
  return (
    <div>
      <Layout>
        <Stores />
      </Layout>
    </div>
  )
}
